import { styled } from "styled-components";

import { fontSizes } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Figure = styled.figure`
    ${redundantCssFromKebab("text-align", "left")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("gap", "1.75rem")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("align-content", "space-between")}

    blockquote {
        ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
        ${redundantCssFromKebab("line-height", "1.25")}
        ${redundantCssFromKebab("margin", "0")}
        ${redundantCssFromKebab("position", "relative")}

        &::before {
            ${redundantCssFromKebab(
                "background-image",
                "url(\"data:image/svg+xml,%3Csvg fill='none' height='31' viewBox='0 0 33 31' width='33' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m32.4 24.1002c0-3.7-2.5-6-6.3-6h-2c.3-7.2 4.1-10.5 8.8-11.30001v-6.599995c-9.3.999995-14.3 7.499995-14.3 18.400005 0 8.6 2.9 11.7 7.5 11.7 3.9 0 6.3-2.7 6.3-6.2zm-18.5 0c0-3.7-2.5-6-6.29999-6h-2c.3-7.2 4.1-10.5 8.79999-11.30001v-6.599995c-9.29999.999995-14.299994 7.499995-14.299994 18.400005 0 8.6 2.900004 11.7 7.500004 11.7 3.89999 0 6.29999-2.7 6.29999-6.2z' fill='%2300a3bf'/%3E%3C/svg%3E\")"
            )}
            ${redundantCssFromKebab("content", '""')}
            ${redundantCssFromKebab("display", "block")}
            ${redundantCssFromKebab("height", "31px")}
            ${redundantCssFromKebab("margin", "0 0 1rem 1rem")}
            ${redundantCssFromKebab("width", "33px")}
        }

        @media (min-width: 768px) {
            ${redundantCssFromKebab("font-size", `${fontSizes.xxl}`)}
            ${redundantCssFromKebab("line-height", "1.34")}
        }
    }

    figcaption {
        ${redundantCssFromKebab("align-items", "start")}
        ${redundantCssFromKebab("display", "flex")}
        ${redundantCssFromKebab("flex-direction", "column")}
        ${redundantCssFromKebab("gap", "1.5rem")}
        ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}

        p {
            ${redundantCssFromKebab("margin-bottom", "0.5rem")}

            &:last-child {
                ${redundantCssFromKebab("margin-bottom", "0")}
            }
        }
    }

    @media (min-width: 992px) {
        ${redundantCssFromKebab("padding-left", "8.33333%")}

        blockquote {
            &::before {
                ${redundantCssFromKebab("left", "-4rem")}
                ${redundantCssFromKebab("margin", "0")}
                ${redundantCssFromKebab("position", "absolute")}
                ${redundantCssFromKebab("top", "0.9rem")}
            }
        }

        figcaption {
            ${redundantCssFromKebab("flex-direction", "row")}
            ${redundantCssFromKebab("justify-content", "space-between")}

            > div:first-child {
                ${redundantCssFromKebab("width", "66.66666%")}
            }
        }
    }
`;

export const LogoWrapper = styled.div`
    img {
        ${redundantCssFromKebab("max-width", "220px")}
        ${redundantCssFromKebab("max-height", "66px")}
        ${redundantCssFromKebab("height", "auto")}
        ${redundantCssFromKebab("width", "auto")}
    }
`;
